
const prefixForHosting = ""

const paths = {
    home:  prefixForHosting + "/",
    home2:  prefixForHosting + "/home",
    blogsMenu: prefixForHosting + "/blogs",
    blog: prefixForHosting + '/blogs/:id',
}


export {paths};